define(['vendor/jquery.fileupload.js', 'app/modules/utilities'], (jqueryFileUpload, Util) => {
  const closePanel = function (panel) {
    const nextPanel = panel.next();
    if (nextPanel.length > 0) {
      nextPanel.find('.panel-title a').click();
    } else {
      panel.find('.panel-title a').click();
    }
  };

  const nextTab = function (tab) {
    const nextTabObject = tab.next();
    if (nextTabObject.length > 0) {
      $(`.section-list a[href="#${nextTabObject.attr('id')}"]`).tab('show');
    }
  };

  const showErrors = function (form, errors, prefix, errorsHtml) {
    const loading_wrapper = form.find('>.loading-wrapper');

    if (errorsHtml) {
      if (loading_wrapper.length > 0) {
        loading_wrapper.prepend(errorsHtml);
      } else {
        form.prepend(errorsHtml);
      }
    }

    const form_errors = form.find('.form-errors');

    $.each(errors, (key, error) => {
      form
        .find(`#${prefix}${key}`)
        .parent()
        .addClass('field_with_errors');
    });

    if (form_errors.length > 0) {
      $('html, body').animate(
        {
          scrollTop: form_errors.offset().top - 80,
        },
        700,
      );
    }
  };

  const hideErrors = function (form) {
    form.find('.alert').remove();
    form.find('.field_with_errors').removeClass('field_with_errors');
  };

  const hideSuccessMessage = function () {
    const $alert = $('.auto-wrap-alert');

    if ($alert.length) {
      $alert.empty();
    }
  };

  const getError = function (result) {
    return result.responseJSON && result.responseJSON.error ? result.responseJSON.error : false;
  };

  const getErrorHtml = function (result) {
    return result.responseJSON && result.responseJSON.error_html
      ? result.responseJSON.error_html
      : false;
  };

  const redirectTo = function (result) {
    if (result.responseJSON && result.responseJSON.redirect_to) { window.location = result.responseJSON.redirect_to; }
  };

  const showSuccess = function (result) {
    if (result.success_html) {
      if ($('.wrap-alert').length) {
        $('.wrap-alert').html(result.success_html);
      } else {
        if (!$('.auto-wrap-alert').length) { $('.main-container').prepend('<div class="auto-wrap-alert"></div>'); }
        $('.auto-wrap-alert').html(result.success_html);
      }
    }
  };

  const submit = function (form, prefix, successCallback) {
    form.find('.loading-wrapper').prepend('<div class="ca-loading"></div>');

    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success(result) {
        hideErrors(form);

        if (result.errors) {
          showErrors(form, result.errors, prefix, result.errors_html);
        } else {
          closePanel(form.parents('.panel'));
          nextTab(form.parent());
          if (successCallback) successCallback(result, form);
        }
        form.find('.ca-loading').remove();
      },
      error(result) {
        hideErrors(form);
        showErrors(form, [], prefix, getErrorHtml(result));
        redirectTo(result);
        form.find('.ca-loading').remove();
      },
    });
  };

  const fileUploadCallback = function (data, input, image_type) {
    const form = input.parents('form');
    hideErrors(form);

    if (data.result[`${image_type}_url`]) {
      const image = $('<img>').attr('src', data.result[`${image_type}_url`]);
      const image_field = form.find(`.company-image-wrap.${image_type}`);
      image_field.find('.area-placeholder.no-image').removeClass('no-image');
      image_field.find('.image').html(image);
    } else {
      showErrors(form, data.result.errors, '', data.result.errors_html);
    }
  };

  const changeInputType = function (tabs, value) {
    tabs.find('.tab-pane.active').removeClass('active');
    tabs.find(`.tab-pane#${value}`).addClass('active');
  };

  const initFileUpload = function (field) {
    field.fileupload({
      acceptFileTypes: /(\.|\/)(jpg|jpeg|gif|png)$/i,
      dataType: 'JSON',
      type: 'PUT',
      replaceFileInput: false,
      url: field.attr('data-url'),
      dropZone: field.parents('.fileUploadArea'),
      formData: { image_type: field.attr('data-imagetype') },
      done(e, data) {
        fileUploadCallback(data, field, field.attr('data-imagetype'));
      },
    });
  };

  var initTeamFileUpload = function (field) {
    field.fileupload({
      acceptFileTypes: /(\.|\/)(jpg|jpeg|gif|png)$/i,
      dataType: 'JSON',
      type: 'PUT',
      replaceFileInput: false,
      url: field.attr('data-url'),
      dropZone: field.parents('.fileUploadArea'),
      formData: { image_type: field.attr('data-imagetype') },
      done(e, data) {
        const form = field.parents('form');
        const fields = field.parents('.fields');
        const image_type = field.attr('data-imagetype');

        if (data.result.new_id) {
          const index = field.attr('data-index');
          const new_url = `${field.attr('data-url')}?member_id=${data.result.new_id}`;
          fields.find('.company-team-image-upload').attr('data-url', new_url);
          field
            .parents('.fields')
            .find(`input[id=company_members_attributes_${index}_id]`)
            .val(data.result.new_id);
          fields.find('.company-team-image-upload').each(function () {
            initTeamFileUpload($(this));
          });
        }

        hideErrors(form);

        if (data.result[`${image_type}_url`]) {
          const image = $('<img>').attr('src', data.result[`${image_type}_url`]);
          const image_field = fields.find(`.company-image-wrap.${image_type}`);
          image_field.find('.area-placeholder.no-image').removeClass('no-image');
          image_field.find('.image').html(image);
        } else {
          showErrors(form, data.result.errors, '', data.result.errors_html);
        }
      },
    });
  };

  const submitWithFiles = function (form, prefix, successCallback) {
    form.find('.loading-wrapper').prepend('<div class="ca-loading"></div>');
    const formData = new window.FormData(form[0]);

    // fix safari 11
    $(form[0])
      .find('input[type=file]')
      .each(function () {
        const $input = $(this);

        if ($input.val() === '') {
          try {
            formData.delete($input.attr('name'));
          } catch (error) {}
        }
      });

    $.ajax({
      xhr() {
        return $.ajaxSettings.xhr();
      },
      dataType: 'json',
      type: form.attr('method'),
      url: form.attr('action'),
      data: formData,
      processData: false,
      contentType: false,
      timeout: 60000, // 1 minute
      success(result) {
        hideErrors(form);
        hideSuccessMessage();

        if (result.notice) toastr.success(result.notice);

        form.find('.ca-loading').remove();
        if (result.errors) {
          if (prefix == 'job_application_' || prefix == 'interest_') {
            localStorage[prefix + form.attr('action').split('/')[2]] = JSON.stringify(form.serializeArray());
          }
          if (prefix == 'student_') {
            localStorage[prefix + form.attr('action').split('/')[4]] = JSON.stringify(form.serializeArray());
          }
          if (prefix == 'user_') {
            localStorage[prefix + form.attr('action').split('/')[1]] = JSON.stringify(form.serializeArray());
          }
          showErrors(form, result.errors, prefix, result.errors_html);
        } else {
          if (prefix == 'job_application_' || prefix == 'interest_') {
            localStorage.removeItem(prefix + form.attr('action').split('/')[2]);
          }
          if (prefix == 'student_') {
            localStorage.removeItem(prefix + form.attr('action').split('/')[4]);
          }
          if (prefix == 'user_') {
            localStorage.removeItem(prefix + form.attr('action').split('/')[1]);
          }
          if (successCallback) successCallback(result, form);
          if (result.external_url && result.external_url != '') {
            $('.modal-redirecting').modal('show');
          } else if (result.redirect_to) {
            window.location = result.redirect_to;
          }
        }
      },
      error(result, textStatus) {
        hideErrors(form);
        hideSuccessMessage();
        let error = getErrorHtml(result);
        if (textStatus === 'timeout' || !result.responseJSON) error = Util.renderErrorHtml();
        showErrors(form, [], prefix, error);
        redirectTo(result);
        form.find('.ca-loading').remove();
      },
    });
  };

  const checkEmailField = function ($field) {
    const $form = $field.closest('form');
    const isSignedIn = $.cookie('signed_in') && $.cookie('signed_in') == 1;
    const $modal = $('#sign-in-modal');
    const email = $field.val();

    $.ajax({
      type: 'GET',
      url: $field.data('url'),
      data: { email },
      success(result) {
        hideErrors($form);

        if (result.errors) {
          showErrors($form, result.errors, '', result.errors_html);

          if (!isSignedIn) {
            $modal.modal('show');
          }
        }
      },
    });
  };

  const hasApplyDirtyInputs = function () {
    let isDirty = false;
    $('.experience-new input, .experience-new textarea, .education-new input, .education-new textarea').each(function () {
      if (
        $(this).attr('type') != 'checkbox' &&
        $(this).val() &&
        ($(this).val() != 'Industries' && $(this).val() != 'Job functions')
      ) {
        isDirty = true;
      }
    });

    if ($('.language-new .dirty').length > 0) {
      isDirty = true;
    }

    return isDirty;
  };

  const hasJobQuestionsDirtyInputs = function () {
    let isDirty = false;
    $('input[name="new_choice_options"]').each(function () {
      if ($(this).val()) {
        isDirty = true;
      }
    });
    return isDirty;
  };

  const ignoreApplyDirtyInputs = function () {
    return !(hasApplyDirtyInputs() && !Util.unsubmittedFieldsConfirm());
  };

  const ignoreJobQuestionsDirtyInputs = function () {
    return !(hasJobQuestionsDirtyInputs() && !Util.unsubmittedFieldsConfirm());
  };

  const ignoreDirtyInputs = function (fields) {
    let isDirty = false;
    fields.each(function () {
      if ($(this).val()) {
        isDirty = true;
      }
    });
    return !(isDirty && !Util.unsubmittedFieldsConfirm());
  };

  const listsValidation = function () {
    let isValid = true;

    if (!$('.languages-list .language').length) {
      $('.languages-list .error').show();
      isValid = false;
    } else {
      $('.languages-list .error').hide();
    }

    if (!$('.degrees-list .degree').length) {
      $('.degrees-list .error').show();
      isValid = false;
    } else {
      $('.degrees-list .error').hide();
    }

    if (!$('.experiences-list .experience').length) {
      $('.experiences-list .error').show();
      isValid = false;
    } else {
      $('.experiences-list .error').hide();
    }
    return isValid;
  };

  const $genderPreferSay = $('.js-shared-gender-prefer-say');
  const $gender = $('.js-shared-gender');

  function bindDisablingCheckbox() {
    $('.js-shared-input-disabling').on('ifChanged', (event) => {
      const $input = $(event.currentTarget);
      const checked = $input.is(':checked');
      const $target = $($input.data('target'));

      $target.attr('disabled', checked);
    });
  }

  function toggleGender() {
    const checked = $genderPreferSay.is(':checked');

    $gender.toggleClass('inactive', checked);
  }

  const bindSharedControls = function () {
    $genderPreferSay.on('ifChanged', toggleGender);

    bindDisablingCheckbox();
    $(document).on('nested:fieldAdded', bindDisablingCheckbox);
    $(document).on('interests:update', bindDisablingCheckbox);
    $(document).on('form:updated', toggleGender);
  };

  function toggleSwitcher($el, silent = false) {
    $el.toggleClass('off');
    $el.find('input[type=radio]').each(function () {
      const $el = $(this);
      if (!$el.prop('checked')) {
        $el.prop('checked', true);
        if (!silent) {
          $el.trigger('change');
        }
        return false;
      }
    });
  }

  return {
    showErrors,
    showSuccess,
    hideErrors,
    getError,
    getErrorHtml,
    redirectTo,
    submit,
    fileUploadCallback,
    changeInputType,
    closePanel,
    nextTab,
    initFileUpload,
    initTeamFileUpload,
    submitWithFiles,
    hasApplyDirtyInputs,
    hasJobQuestionsDirtyInputs,
    ignoreApplyDirtyInputs,
    ignoreJobQuestionsDirtyInputs,
    ignoreDirtyInputs,
    listsValidation,
    checkEmailField,
    bindSharedControls,
    toggleSwitcher,
  };
});
